import { BaseEntity } from "yt-ng-framework";

export class Okrug extends BaseEntity{
    constructor(){
        super();
    };

    Naziv:string = null;
    DrzavaID:number = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.DrzavaID = input.DrzavaID;       
        return this;
    }

    Serialize(input: Okrug){
        return input;
    }

}